export default function Logo({ size = 36, className = "" }) {
  return (
    <div>
      <img
        src="/logo.png"
        alt="ZyrisX"
        width={size}
        height={size}
        className={className}
        data-testid="zyrisx-logo"
      />
      <p className="zx-label">La Lista</p>
    </div>
    
  );
}
